import DrillDownBuilder from './DrillDownBuilder';
import ManualBuilder from './ManualBuilder';

const OmniSearch = {
  DrillDownBuilder,
  ManualBuilder,
};

export default OmniSearch;
